import moment from 'moment';
import Constants from '../../utils/constants';
import BaseUserService from '../BaseUserService';
import DateUtils from '../../utils/DateUtils';

const path = 'timehero/userReportedDay/week';
export default class DayViewService extends BaseUserService {
    // Initializing important variables
    constructor() {
        super(path);
        this.path = path;
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            selectedDay: moment(criteria.selectedDay).format(Constants.DATE_JSON_FORMAT)
        });
    }

    list(query) {
        let path = `${this.domain}/${this.path}/list-ac`;
        if (query) {
            path += `?query=${query}`;
        }
        return this.fetch(path, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    validateTime(time){
        return (time!== null && time !== undefined) && DateUtils.isValidDate(time);
    }
   
    normalizeElement(element, day) {
        const daysFromMonday = Math.abs(moment(day).day() - 1);
        const weekStart = moment(day).subtract(daysFromMonday, 'day');
        element?.events.forEach((eventList) => {
            eventList.forEach((x) => {
                if (x !== null) {
                    const format = 'HH:mm:ss'
                    x.selectedDay = DateUtils.isValidDate(weekStart) ? moment(weekStart).format(Constants.DATE_JSON_FORMAT) : null;
                    x.userTime = this.validateTime(x.userTime) ? moment(x.userTime).format(format) : null;
                    x.creativeTime = this.validateTime(x.creativeTime) ? moment(x.creativeTime).format(format) : null;
                    x.timeFrom = this.validateTime(x.timeFrom) ? moment(x.timeFrom).format(format) : null;
                    x.timeTo = this.validateTime(x.timeTo) ? moment(x.timeTo).format(format) : null;
                }
            });
            weekStart.add(1, 'day');
        });
        if (element.project) {
            element.project = this.keepOnlyId(element.project)
        }
        if (element.activity) {
            element.activity = this.keepOnlyId(element.activity);
        }
        if (element.client) {
            element.client = this.keepOnlyId(element.client);
        }
        return element;
    }


    keepOnlyId(obj) {
        return {
            id: obj.id
        };
    }


    add(element, day) {
        const e = this.normalizeElement(this.cloneElement(element), day);
        return this.fetch(`${this.domain}/${this.path}/add`, {
            method: 'POST',
            body: JSON.stringify(e),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    update(element, day, weekSelected) {
        const e = this.normalizeElement(this.cloneElement(element), day);
        return this.fetch(`${this.domain}/${this.path}?weekSelected=${weekSelected}`, {
            method: 'PUT',
            body: JSON.stringify(e),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }


    approve(ids) {
        return this.fetch(`${this.domain}/${this.path}/approve?userDayIds=${ids}`, {
            method: 'POST',
            body: JSON.stringify(ids)
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    open(ids) {
        return this.fetch(`${this.domain}/${this.path}/open?userDayIds=${ids}`, {
            method: 'POST',
            body: JSON.stringify(ids)
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
 
    delete(eventIndex) {
        return this.fetch(`${this.domain}/${this.path}/${eventIndex}`, {
            method: 'DELETE'
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    deleteRow(eventIds){
        return this.fetch(`${this.domain}/${this.path}/row?eventIds=${eventIds}`, {
            method: 'DELETE'
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
